module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAAV0lEQVQoFZXBsREDMQDDMHL/oRUWLr6Kz4A8kkdyLMTwsRBD5FiI4WMhhsixEMPHQgyRYyGGj4UYIsfCH4bIsfCHIXKxEEPkYiGGyMVCDJGLhRgij+TRD2EzOA+OX8gAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_context_04.png
// module id = 226
// module chunks = 0